export default __webpack_public_path__ + "static/media/pause.70490ffa.png";